module.exports = new __parcel__URL__("ai-notes-icon.f866806e.svg").toString();